import React, { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Layout,
  Flex,
  Card,
  Row,
  Col,
  Select,
  Radio,
  Table,
  Badge,
  Divider,
  Button,
  Spin,
  Avatar,
  Tag,
  Checkbox,
  Input,
  Tooltip as AntTooltip,
  Segmented,
  Tabs,
  DatePicker,
} from "antd";
import {
  LineChart,
  Line,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
  LabelList,
} from "recharts";

import {
  FilterOutlined,
  InfoCircleOutlined,
  MoreOutlined,
  RiseOutlined,
  FallOutlined,
  EllipsisOutlined,
  UserOutlined,
  DownOutlined,
  UpOutlined,
  ArrowDownOutlined,
  ArrowUpOutlined,
  CloseOutlined,
  CloseCircleOutlined,
  SearchOutlined,
  CloudFilled,
  EditOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import "./NewDashboard.css";
import axios from "axios";
import { BE_HOST } from "../../config/config";
import AlertMessage from "./AlertMessage/AlertMessage";
import HeaderCompo from "../../component/Header";
import { axiosInstance } from "../../utils/axiosInterceptor";
import CalculationModal, {
  GCRTooltipTable,
  GPRTooltipTable,
  SGCRTooltipTable,
} from "./calculationModal/CalculationModal";
import { setPharmacyData, setPharmacyLabel } from "../../redux/reducer/dataReducer";
import { formatMonthLabel, formatQuarterLabel } from "../../utils/helper";
import Chat from "../../components/chats/Chat";
import InputPopUp from "../../components/InputPopUp/InputPopUp";
import { QuarterTargetTable, SGCRTargetTable } from "../../components/tables/NarrowTable";
import dayjs from 'dayjs';
import { Headphones, MessageCircle } from "lucide-react";
import applogo from "../../assets/aapaNewlogoTm.png"
// import { data } from "../../sample_data";
const { Content } = Layout;
const { Option } = Select;

const generateHeaderData = () => {
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];

  const currentDate = new Date();
  const monthData = [];
  const quarterData = [];

  // Generate last 6 months data
  // for (let i = 0; i < 12; i++) {
  //   const date = new Date(currentDate);
  //   date.setMonth(date.getUTCMonth() - i);
  //   const month = date.getUTCMonth();
  //   const year = date.getUTCFullYear();

  //   monthData.unshift({
  //     label: `${months[month]} ${year}`,
  //     value: `${month + 1}`,
  //     key: `${months[month]} ${year}`
  //   });
  // }
  const currentMonth = currentDate.getUTCMonth(); // 0-based
  const currentYear = currentDate.getUTCFullYear();

  for (let i = 11; i >= 0; i--) {
     const date = new Date(currentDate);
    date.setMonth(date.getUTCMonth() - i);

    const month = date.getUTCMonth(); // 0-based
    const year = date.getUTCFullYear();
  for (let i = 11; i >= 0; i--) {
    const date = new Date(currentDate);
    date.setMonth(date.getUTCMonth() - i);

    const month = date.getUTCMonth(); // 0-based
    const year = date.getUTCFullYear();
    monthData.push({
      label: `${months[month]} ${year}`,
      value: `${month + 1}`,
      key: `${months[month]} ${year}`,
    });
  }

  // Generate quarters data (last 4 quarters)
  for (let i = 0; i < 4; i++) {
    const date = new Date(currentDate);
    date.setMonth(date.getUTCMonth() - i * 3);
    const quarter = Math.floor(date.getUTCMonth() / 3) + 1;
    const year = date.getUTCFullYear();

    quarterData.unshift({
      label: `${quarter}${getOrdinalSuffix(quarter)} Quarter ${year}`,
      value: `${quarter}`,
      key: `${quarter}${getOrdinalSuffix(quarter)} Quarter ${year}`,
    });
  }

  return {
    month: monthData,
    quarter: quarterData,
  };
};}

// Helper function to add ordinal suffix
const getOrdinalSuffix = (num) => {
  const suffixes = ["th", "st", "nd", "rd"];
  const v = num % 100;
  return suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0];
};

// Replace the static getHeaderdata with the dynamic one
const getHeaderdata = generateHeaderData();
const { TabPane } = Tabs;

const NewDashboard = () => {
  // API state
  // const [token, setToken] = useState("");
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const accountIdParams = searchParams.get("accountId");
  const accountName = searchParams.get("accountName");
  const supplierId = searchParams.get("supplier_id");
  const baseAcctId = searchParams.get("acct_id");
  const is_chat_support = searchParams.get("is_chat_support")
  const [AllUser, setAllUser] = useState([]);
  const [selectedPharmacies, setSelectedPharmacies] = useState(accountIdParams ? [Number(accountIdParams)] : []);
  const [selectedfilter, setselectedfilter] = useState("month");
  const [selectedfilter2, setselectedfilter2] = useState("month");

  const [rebatePerformance, setRebatePerformace] = useState([]);
  const navigate = useNavigate();
  const [modalVisible, setModalVisible] = useState(false);
  const [loadingCalc, setloadingCalc] = useState(false);
  // Find current month's option from the dropdown
  const [isVisible, setIsVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [activePeriod, setActivePeriod] = useState("current");
  const [quarterGCRTarget, setQuarterGCRTarget] = useState("");
  const [SGCRTarget, setSGCRTarget] = useState("");
  const [GPRTarget, setGPRTarget] = useState("");
  const [inputTargetValue, setInputTarget] = useState();
  const [year, setYear] = useState(new Date().getUTCFullYear());
  const [GCRPer, setAPIdata] = useState([]);
  const [TopRxSpentSQL, setTopRxSpentSQL] = useState([]);
  const [TopLeakDetails, setTopLeakDetails] = useState([]);
  const [TrailingData, setTrailingData] = useState([]);
  // const [EstimatedGPR, setEstimatedGPR] = useState([]);
  const [QuarterGCR, setQuarterGCR] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState(AllUser);
  const [allUserFetched, setAllUserFetched] = useState(false); // new flag
  const [calculatedData, setCalculatedData] = useState([]);
  const [gcrPercentage, setGcrPercentage] = useState([]);
  const [selectedGcr, setSelectedGcr] = useState(null);
  const [animateValues, setAnimateValues] = useState(false);
  const [quarterGcrPer, setQuarterGcrPercentage] = useState([]);
  const [monthSgcrPer, setMonthSgcrPercentage] = useState([]);
  const [monthGprPer, setMonthGrPercentage] = useState([]);
  const [chatBoxOpen, setChatOpen] = useState(false);
  const [adminChatBot, setAdminChat] = useState(false);
  const [admin, setAdmin] = useState(true);
  const [targetPopUP, setTargetPopUp] = useState(false);
  const [selectedValue, setSelectedValue] = useState("");
  const [targetLoading, setTargetLoading] = useState(false);
  const [QuarterTableData,setQuarterTableData] = useState([])
  const [SgcrTableData,setSgcrTableData] = useState([])
  const [isSupportActive,setIsSupportActive] = useState(false)

  const dispatch = useDispatch();
  const { loading } = useSelector(
    (state) => state.accounts || { assignedAccounts: [], loading: false }
  );
  const userAuth = useSelector((state) => state.userAuth.decodedToken?.user);
  const token = localStorage.getItem("token");

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);

    // Cleanup on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const getCurrentMonthOption = () => {
    const now = dayjs();

  const label = now.format("MMM YYYY"); // Jan 2026
  const monthValue = now.format("M");   // 1
  const year = now.format("YYYY");      // 2026

  return {
    key: label,
    label: label,
    value: monthValue,
    year: year,
  };
    // const currentDate = new Date();
    // const currentMonth = currentDate.getUTCMonth() + 1; // JavaScript months are 0-11
    // const currentYear = currentDate.getUTCFullYear();

    // return (
    //   getHeaderdata["month"].find((option) => {
    //     const [monthName, year] = option.label.split(" ");
    //     return (
    //       parseInt(option.value) === currentMonth &&
    //       parseInt(year) === currentYear
    //     );
    //   }) || getHeaderdata["month"][0]
    // ); // Fallback to first option if current month not found
  };

  const [selectedOption, setSelectedOption] = useState(getCurrentMonthOption());

  const updatePharmacies = (value,pharmacy) => {
    setSelectedPharmacies(value);
    dispatch(setPharmacyData(value));
    dispatch(setPharmacyLabel(pharmacy?.at(-1)?.name));
  };

  // const handleChange = (value) => {
  //   setselectedfilter(value);
  //   // When filter changes, automatically set first option from new filter type
  //   setSelectedOption(getHeaderdata[value][2]);
  // };

  // console.log(year,"Year")
  // const handlemonth = (value) => {
  //   const select = getHeaderdata[selectedfilter].find(
  //     (item) => item.value === value
  //   );
  //   // console.log("this is for selecet option=====>", select);
  //   if (selectedfilter === "month") {
  //     const [, year] = select?.label?.split(" ") || "2024";
  //     setYear(year);
  //   } else if (selectedfilter === "quarter") {
  //     // Split "1st Quarter 2025" into ["1st", "Quarter", "2025"]
  //     const [, , year] = select?.label?.split(" ") || ["", "", "2024"];
  //     setYear(year);
  //   }
  //   setSelectedOption(select);
  // };
  // function formatWithCommas(number) {
  //   return number.toLocaleString("en-US", {
  //     minimumFractionDigits: 2,
  //     maximumFractionDigits: 2,
  //   });
  // }

  // Add loading state
  const [isLoading, setIsLoading] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false);

  // Add this function to calculate dates for both month and quarter
  const getDateRange = (filter, selectedValue, selectedYear) => {
    if (filter === "quarter") {
      const quarters = {
        1: { start: "01-01", end: "03-31" },
        2: { start: "04-01", end: "06-30" },
        3: { start: "07-01", end: "09-30" },
        4: { start: "10-01", end: "12-31" },
      };
      return {
        fromDate: `${selectedYear}-${quarters[selectedValue].start}`,
        thruDate: `${selectedYear}-${quarters[selectedValue].end}`,
      };
    } else {
      // For monthly view
      const today = new Date();
      const month = selectedValue.padStart(2, "0");
      const startDate = `${selectedYear}-${month}-01`;
      const thruDate =
        today.getUTCFullYear() === parseInt(selectedYear) &&
        today.getUTCMonth() + 1 === parseInt(selectedValue)
          ? today.toISOString().split("T")[0] // If current month, use today's date
          : new Date(selectedYear, selectedValue, 0)
              .toISOString()
              .split("T")[0]; // Last day of selected month

      return { fromDate: startDate, thruDate };
    }
  };

  // Modify the fetchAllData function to handle loading state
  const apiVersion =
    (Number(selectedOption?.year) > 2025 ||
    (Number(selectedOption?.year) === 2025 && Number(selectedOption.value) >= 9)) ? "/v2": "";
    const apiVersionUsers =
     (Number(selectedOption?.year) > 2025 ||
    (Number(selectedOption?.year) === 2025 && Number(selectedOption.value) >= 9)) ? "/api/v2": "";
    
  // const isBeforeOrEqualMarch2026 =
  // (Number(selectedOption?.year) >= 2026 && Number(selectedOption?.value) >= 1 && Number(selectedOption?.value) <= 3);

  const fetchAllData = async () => {
    if (!token) return;

    setIsLoading(true); // Set loading to true when fetching starts
    try {
      setIsLoading(true);

      // Get dates based on selected quarter
      const { fromDate, thruDate } = getDateRange(
        selectedfilter,
        selectedOption.value,
        selectedOption?.year
      );

      // fetch all user account
      const getUserAccount = await axiosInstance.get(
        `${BE_HOST}${apiVersionUsers}/users/accounts?email=${userAuth?.email}`
      );
      setAllUser(getUserAccount.data.data.data);

      // Fetch GCR Percentage
      if (
        getUserAccount?.data?.data?.data?.length > 0 &&
        selectedPharmacies?.length > 0
      ) {
        const gcrRes = await axiosInstance.get(
          `/api${apiVersion}/powerbi/getGCRPercentage?token=${token}&period=${selectedfilter}&value=${selectedOption.value}&year=${selectedOption?.year}&accounts=${selectedPharmacies}`
        );
        // console.log(gcrRes,"gcrResgcrResgcrRes")
        setAPIdata(gcrRes.data);
        if (gcrRes.data) {
          // Parallel fetch for remaining APIs
          await Promise.all([
            // Fetch Top Leakage Details
            axiosInstance
              .get(
                `${BE_HOST}${apiVersionUsers}/users/gpr?skip=0&take=30&requireTotalCount=true&FromDate=${fromDate}&ThruDate=${thruDate}&store_id=${selectedPharmacies}&_=1742128891663&parent_store_id=96167`
              )
              .then((LeakDetails) => setTopLeakDetails(LeakDetails.data)),

            // Fetch Top RX Generic Drugs
            axiosInstance
              .get(
                `${BE_HOST}/api${apiVersion}/powerbi/table/getTopRxSpentSQL?period=${selectedfilter}&value=${selectedOption.value}&year=${selectedOption?.year}&accounts=${selectedPharmacies}`
              )
              .then((RxSpentSQL) => setTopRxSpentSQL(RxSpentSQL.data.results)),

            // Fetch Trailing Data API
            axiosInstance
              .get(
                `${BE_HOST}/api${apiVersion}/powerbi/table/getGPRTrailingData?accounts=${selectedPharmacies}&period=${selectedfilter}&value=${selectedOption.value}&year=${selectedOption?.year}`
              )
              // .then((ApiTrailing) => setTrailingData(ApiTrailing.data.data)),
              .then((ApiTrailing) => {
                const sortedData = [...ApiTrailing.data.data].sort((a, b) => {
                  return (
                    new Date(b.sort_date).getTime() -
                    new Date(a.sort_date).getTime()
                  );
                });
                setTrailingData(sortedData);
              }),

            // Fetch QuarterGCR API only when quarter filter is selected
            selectedfilter === "quarter" &&
              axiosInstance
                .get(
                  `/api/powerbi/getQuarterGCR?token=${token}&period=${selectedfilter}&value=${selectedOption.value}&year=${selectedOption?.year}&accounts=${selectedPharmacies}&quarters=${selectedOption.value}`
                )
                .then((ApiQuarterGCR) => {
                  // console.log(ApiQuarterGCR,"apieeeee result")
                  setQuarterGCR(ApiQuarterGCR.data);
                }),
            axiosInstance
              .get(
                `/api${apiVersion}/powerbi/getRebateSummaryLast7Months?token=${token}&period=${selectedfilter}&value=${selectedOption.value}&year=${selectedOption?.year}&accounts=${selectedPharmacies}`
              )
              .then((ApiMonthlyRebateValues) => {
                // console.log(ApiMonthlyRebateValues,"apimonthlyreabate values")
                setRebatePerformace(ApiMonthlyRebateValues.data);
              }),
          ]);
        }
      }
    } catch (err) {
      console.error("Error fetching dashboard data:", err);
    } finally {
      setIsLoading(false);
      setAllUserFetched(true); // ✅ important
    }
  };

  const fetchCalculationData = async (item = null, gcrp) => {
    let data = {};
    if (selectedPharmacies?.length == 0 || !selectedOption?.value) {
      return;
    }
    if (item !== null) {
      setselectedfilter2(item?.selectedfilter);
      data.accounts = selectedPharmacies;
      data.view = item?.selectedfilter;
      data.year = item?.year;
      if (item?.selectedGcr) {
        // data.tier = item?.selectedGcr || tierValue;
        data.tier = item?.selectedGcr;
      }
      if (item?.selectedfilter === "month") {
        data.month = item?.selectedOption?.value;
      } else {
        data.quarter = item?.selectedOption?.value;
      }
    } else {
      data.accounts = selectedPharmacies;
      data.month = new Date().getUTCMonth() + 1;
      data.year = new Date().getUTCFullYear();;
      // target: gcrper
      data.view = "month";
    }
    setloadingCalc(true);
    try {
      const response = await axiosInstance.get(`${apiVersionUsers}/users/gcr/optimizer`, {
        params: data,
      });
      setCalculatedData(response?.data);
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setloadingCalc(false);
    }
  };

  // console.log(selectedOption,"selectedoptionsss")

  const fetchgprPercentage = async (item = null, itemnew = null) => {
    try {
      const currentView = item || selectedfilter2;
      const response = await axiosInstance.get(`/users/gcr/limits`, {
        params: {
          view: currentView,
        },
      });
      const data = response?.data?.tiers || [];
      setGcrPercentage(data);
      fetchCalculationData(itemnew, response?.data?.tiers);
    } catch (error) {
      console.error("Error:", error);
    } finally {
    }
  };

  // const fetchgprPercentageForQuarter = async () => {
  //   try {
  //     const response = await axiosInstance.get(`/users/data/gcr`, {
  //       params: {
  //         view: "quarter",
  //       },
  //     });
  //     const data = response?.data?.tiers || [];
  //     setQuarterGcrPercentage(data);
  //   } catch (error) {
  //     console.error("Error:", error);
  //   } finally {
  //   }
  // };

  const fetchGcrData = async (view, setter) => {
    try {
      const response = await axiosInstance.get(`/users/data/gcr`, {
        params: { view },
      });
      const data = response?.data?.tiers || [];
      setter(data);
    } catch (error) {
      console.error(`Error fetching ${view} GCR/SGCR:`, error);
    }
  };

  const fetchgprPerData = async () => {
    try {
      const response = await axiosInstance.get(`/users/data/gpr`);
      const data = response?.data?.tiers || [];
      setMonthGrPercentage(data);
    } catch (error) {
      console.error("Error:", error);
    } finally {
    }
  };

  useEffect(() => {
    fetchgprPercentage();
    // fetchgprPercentageForQuarter();
    fetchGcrData("quarter", setQuarterGcrPercentage);
    fetchGcrData("month", setMonthSgcrPercentage);
    fetchgprPerData();
  }, []);
  //   useEffect(() => {
  //   if (GCRPer?.MON_SGCR_Percentage || GCRPer?.QTD_GCR_Percentage) {
  //     fetchgprPercentage();
  //   }
  // }, [GCRPer,selectedPharmacies]);

  useEffect(() => {
    fetchCalculationData();
  }, [ GCRPer, selectedPharmacies]);

  useEffect(() => {
    if (!allUserFetched) return;
    if (AllUser?.length > 0 && selectedPharmacies?.length === 0) {
      // setSelectedPharmacies([AllUser[0].acct_id]);
      const specialUser = AllUser?.find((user) => user?.acct_id === 96167);
      if (specialUser) {
        setSelectedPharmacies([specialUser?.acct_id]);
        dispatch(setPharmacyData([specialUser?.acct_id]));
        dispatch(setPharmacyLabel(specialUser?.name))
      } else {
        setSelectedPharmacies([AllUser[0]?.acct_id]);
        dispatch(setPharmacyData([AllUser[0]?.acct_id]));
         dispatch(setPharmacyLabel(AllUser[0]?.name))
      }
    } else if (AllUser?.length == 0 && selectedPharmacies.length === 0) {
      setModalVisible(true);
    }
  }, [AllUser, selectedPharmacies, allUserFetched]);

  const GenericRx = Number(
    isNaN(GCRPer?.raw_data?.Generic_Rx) ? 0 : GCRPer?.raw_data?.Generic_Rx || 0
  ).toFixed(2);

  const OnStopGeneric = Number(
    isNaN(GCRPer?.raw_data?.OnStop_Generic)
      ? 0
      : GCRPer?.raw_data?.OnStop_Generic || 0
  ).toFixed(2);

  const TotalRx = Number(
    isNaN(GCRPer?.raw_data?.Total_Rx) ? 0 : GCRPer?.raw_data?.Total_Rx || 0
  ).toFixed(2);

  const Brand_Rx = Number(
    isNaN(GCRPer?.raw_data?.Brand_Rx) ? 0 : GCRPer?.raw_data?.Brand_Rx || 0
  ).toFixed(2);

  const estimatedCurrentRebate = Number(
    isNaN(GCRPer?.raw_data?.estimatedCurrentRebate)
      ? 0
      : GCRPer?.raw_data?.estimatedCurrentRebate || 0
  ).toFixed(2);

  // Last Period

  const last_GenericRx = Number(
    isNaN(GCRPer?.lastMetrics?.Generic_Rx)
      ? 0
      : GCRPer?.lastMetrics?.Generic_Rx || 0
  ).toFixed(2);

  const last_OnStopGeneric = Number(
    isNaN(GCRPer?.lastMetrics?.OnStop_Generic)
      ? 0
      : GCRPer?.lastMetrics?.OnStop_Generic || 0
  ).toFixed(2);

  const last_TotalRx = Number(
    isNaN(GCRPer?.lastMetrics?.Total_Rx)
      ? 0
      : GCRPer?.lastMetrics?.Total_Rx || 0
  ).toFixed(2);

  const last_Brand_Rx = Number(
    isNaN(GCRPer?.lastMetrics?.Brand_Rx)
      ? 0
      : GCRPer?.lastMetrics?.Brand_Rx || 0
  ).toFixed(2);

  const last_estimatedCurrentRebate = Number(
    isNaN(GCRPer?.lastMetrics?.estimatedCurrentRebate)
      ? 0
      : GCRPer?.lastMetrics?.estimatedCurrentRebate || 0
  ).toFixed(2);

  const performanceData = [
    {
      metric: "Total Rx Spend",
      lastPeriod: last_GenericRx,
      thisPeriod: GenericRx,
    },
    {
      metric: "Total Brand Rx Spend",
      lastPeriod: last_Brand_Rx,
      thisPeriod: Brand_Rx,
    },
    {
      metric: "Total Generic Rx Spend",
      lastPeriod: last_TotalRx,
      thisPeriod: TotalRx,
    },
    {
      metric: "One-STOP Generic Spend",
      lastPeriod: last_OnStopGeneric,
      thisPeriod: OnStopGeneric,
    },
    {
      metric: "Estimated Current Rebate",
      lastPeriod: last_estimatedCurrentRebate,
      thisPeriod: estimatedCurrentRebate,
    },
  ];

  const staticGPRData = [
    { period: "Sep 22", threeMonthAvg: 78, sixMonthAvg: 48 },
    { period: "Oct 22", threeMonthAvg: 36, sixMonthAvg: 30 },
    { period: "Nov 22", threeMonthAvg: 63, sixMonthAvg: 66 },
    { period: "Dec 22", threeMonthAvg: 48, sixMonthAvg: 59 },
    { period: "Jan 23", threeMonthAvg: 72, sixMonthAvg: 77 },
    { period: "Feb 23", threeMonthAvg: 66, sixMonthAvg: 90 },
  ];
  // Get Token
  // useEffect(() => {
  //   const getToken = async () => {
  //     try {
  //       let res = await axios.get(
  //         `${BE_HOST}/api/powerbi/getPowerBIAccessToken`
  //       );
  //       setToken(res.data.access_token);
  //     } catch (err) {
  //       console.error("Error fetching token:", err);
  //     }
  //   };
  //   getToken();
  // }, []);

  // useEffect(() => {
  //   if (AllUser?.length > 0 && !selectedPharmacies.length) {
  //     // Try to find NEW MO-TOWN PHCY first
  //     const defaultPharmacy = AllUser.find(
  //       (pharmacy) =>
  //         pharmacy.name === "NEW MO-TOWN PHCY" ||
  //         pharmacy.label === "NEW MO-TOWN PHCY"
  //     );

  //     // If NEW MO-TOWN PHCY exists, use it; otherwise use the first pharmacy
  //     const pharmacyToUse = AllUser[0] || defaultPharmacy ;
  //     console.log(pharmacyToUse,"pharmacyToUsepharmacyToUse")
  //     if (pharmacyToUse?.acct_id) {
  //       setSelectedPharmacies([pharmacyToUse.acct_id]);
  //     }
  //   }
  // }, [AllUser]);
  useEffect(() => {
    fetchAllData();
    getTargetData();
    setAnimateValues(true);
    const timer = setTimeout(() => setAnimateValues(false), 500);
    return () => clearTimeout(timer);
  }, [selectedfilter, selectedOption, selectedPharmacies]);

  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  // Step 1: Transform and Sort Data
  const processedRebateData = [...rebatePerformance]
    .map((item) => ({
      ...item,
      month: `${monthNames[item.month_num - 1]} ${item.year}`,
    }))
    .sort((a, b) => {
      if (a.year !== b.year) return b.year - a.year;
      return b.month_num - a.month_num;
    });

  useEffect(() => {
    const filtered = AllUser.filter(
      (user) =>{
        const { displayName, displayId } = getDisplayPharmacy(user);
        return(
          displayName.toLowerCase().includes(searchText.toLowerCase()) ||
          String(displayId || "").includes(searchText)
        )
        // user.name?.toLowerCase().includes(searchText.toLowerCase()) ||
        // String(user?.acct_id || "").includes(searchText.toLowerCase())
      }
    );
    setFilteredUsers(filtered);
  }, [searchText, AllUser]);

  const isCurrentMonth = (monthData) => {
    const now = new Date();
    const currentMonth = now.getUTCMonth() + 1; // 1-12
    const currentYear = now.getUTCFullYear();

    if (
      parseInt(monthData.value) === currentMonth &&
      monthData.key.includes(currentYear)
    ) {
      return true;
    } else {
      return false;
    }
  };

const handleTarget = (label, val) => {
    setSelectedValue(label);
    setInputTarget(val);
    setTargetPopUp(true);
  };

  const getTargetData = async () => {
    if (selectedPharmacies?.length === 0 || !selectedOption?.year) return;
    setTargetLoading(true);
    try {
      const response = await axiosInstance.get(
        `${BE_HOST}/api/v2/powerbi/targets?accounts=${selectedPharmacies}&period=month&year=${selectedOption?.year}&month=${Number(selectedOption?.value)}&email=${userAuth?.email}`
      );
      // const filterData = response?.data?.targets?.filter(
      //   (item) => item?.email === userAuth?.email
      // )?.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
      const filterData = response?.data?.targets;
      if (filterData?.length > 0) {
        setQuarterGCRTarget(filterData[0]?.Quarter_GCR);
        setSGCRTarget(filterData[0]?.Month_SGCR);
        setGPRTarget(filterData[0]?.Month_GPR);
      }
      else{
        setQuarterGCRTarget(0);
        setSGCRTarget(0);
        setGPRTarget(0);
      }
    } catch (error) {
      console.log(error, "error in gettargetDataaaa");
    } finally {
      setTargetLoading(false);
    }
  };

  const isSelectedCurrentMonth = () => {
    const currentMonth = new Date().getUTCMonth() + 1;
    return (Number(selectedOption?.value) === currentMonth &&  selectedOption?.year == new Date().getUTCFullYear());
  };

  
  useEffect(()=>{
    getQuarterGCRTableData();
    getSGCRTableData()
  },[selectedOption,quarterGCRTarget,SGCRTarget])
   const getQuarterGCRTableData = async () => {
    const quarter = Math.ceil((new Date().getUTCMonth() + 1) / 3);
    let data = {};
    if (selectedPharmacies?.length == 0 || !selectedOption?.value || quarterGCRTarget==0) {
      return;
    }
      data.accounts = selectedPharmacies;
      data.quarter = quarter;
      data.year = selectedOption?.year;
      data.tier = quarterGCRTarget;
      data.view = "quarter";
    // setloadingCalc(true);
    try {
      const response = await axiosInstance.get(`${apiVersionUsers}/users/gcr/optimizer`, {
        params: data,
      });
      setQuarterTableData(response?.data);
    } catch (error) {
      console.error("Error:", error);
    } finally {
      // setloadingCalc(false);
    }
  };
  const getSGCRTableData = async () => {
    let data = {};
    if (selectedPharmacies?.length == 0 || !selectedOption?.value) {
      return;
    }
      data.accounts = selectedPharmacies;
      data.month = selectedOption?.value;
      data.year = selectedOption?.year;
      data.tier = SGCRTarget;
      data.view = "month";
    // setloadingCalc(true);
    try {
      const response = await axiosInstance.get(`${apiVersionUsers}/users/gcr/optimizer`, {
        params: data,
      });
      setSgcrTableData(response?.data);
    } catch (error) {
      console.error("Error:", error);
    } finally {
      // setloadingCalc(false);
    }
  };

  
  const disabledMonth = (current) => {
  const MIN_MONTH = dayjs("2025-01", "YYYY-MM");
  const MAX_MONTH = dayjs(); // always current month
  if (!current) return false;

  return (
    current.isBefore(MIN_MONTH, "month") ||
    current.isAfter(MAX_MONTH, "month")
  );
};
const onChangeMonth = (date) => {
  if (!date) return;

  const label = date.format("MMM YYYY"); // Jan 2026
  const monthValue = date.format("M");   // 1
  const year = date.format("YYYY");      // 2026

  const option = {
    key: label,
    label: label,
    value: monthValue,
    year: year,
  };

  setSelectedOption(option);
};

const getDisplayPharmacy = (account) => {
  const isGoodUser = userAuth?.user_roles_id === 5;

  if (isGoodUser && account?.acct_id === 96167) {
    return {
       ...account,
      displayName: "ABC Pharmacy",
      displayId: "123456",
    };
  }
  return {
    ...account,
    displayId: account.acct_id,
    displayName: account.name || account.label,
  };
};

const getQuarterTarget = (item,tiers,actualTarget,setstate) => {
  if(!item) return;
  const target = Number(actualTarget);
  if (target && target > 0) {
    return target?.toFixed(2);
  }

  const currentValue = Number(item?.value || 0);

  const sortedTiers = [...(tiers || [])].sort(
    (a, b) => a?.lower_limit - b?.lower_limit
  );

  const nextTier = sortedTiers.find(
    (tier) => tier?.lower_limit > currentValue
  );

  if (nextTier) {
    return Number(nextTier?.lower_limit)?.toFixed(2);
  }
  return Number(
    sortedTiers?.[sortedTiers.length - 1]?.lower_limit || 0
  ).toFixed(2);
};
const getGPRTarget = (item,tiers,actualTarget) => {
  if(!item) return;
  const target = Number(actualTarget);
  if (target && target > 0) {
    return target?.toFixed(2);
  }

  const currentValue = Number(item?.value || 0);

    const gprTiers = (tiers || [])?.filter(
    (tier) => tier?.category === "Brand"
  );
  const sortedTiers = [...(gprTiers || [])].sort(
    (a, b) => a?.lower_limit - b?.lower_limit
  );

  const nextTier = sortedTiers.find(
    (tier) => tier?.lower_limit > currentValue
  );

  if (nextTier) {
    return Number(nextTier?.lower_limit)?.toFixed(2);
  }

  return Number(
    sortedTiers?.[sortedTiers.length - 1]?.lower_limit || 0
  ).toFixed(2);
};
const formatDate = (dateString) => {
    const date = new Date(dateString);

    const day = date.getUTCDate();

    const getOrdinal = (n) => {
      if (n > 3 && n < 21) return `${n}th`;
      switch (n % 10) {
        case 1:
          return `${n}st`;
        case 2:
          return `${n}nd`;
        case 3:
          return `${n}rd`;
        default:
          return `${n}th`;
      }
    };

    const month = date.toLocaleString("en-US", { month: "long", timeZone: "UTC" });
    const year = date.getUTCFullYear();

    return `${getOrdinal(day)} ${month}, ${year}`;
  };
useEffect(()=>{
  if(!!supplierId) {
    localStorage.setItem("supplierId",JSON.stringify(supplierId));
    localStorage.setItem("baseAcctId",JSON.stringify(baseAcctId));
    setIsSupportActive(true);
    setChatOpen(true)
  }
},[supplierId,baseAcctId])

useEffect(() => {
  if (is_chat_support) {
    const timer = setTimeout(() => {
      setIsSupportActive(false);
      setChatOpen(true);
    }, 2000);

    return () => clearTimeout(timer);
  }
}, [is_chat_support]);

  const formatMonthYear = (date) => {
  if (!date) return "";

  const [year, month] = date.split("-");
  return `${month}-${year}`;
};

  return (
    <>
      <HeaderCompo initialColor={"#000833"} />
      <Layout className="min-h-screen p-2 dashboard-layout-bg">
        <Content className="p-6 bg-[#000833] mb-8 rounded-lg ">
          {isLoading ? (
            <div className="flex justify-center items-center h-[30vh] bg-[transparent]">
              <Spin size="large" className="text-white " />
            </div>
          ) : (
            <div className="flex flex-col justify-center align-center  sm:flex-row sm:justify-between sm:items-center mb-4 mt-2 gap-4 w-full">
              {AllUser && AllUser.length > 0 && (
                <div className="order-2 sm:order-1 w-full sm:w-auto sm:max-w-[43%] flex justify-center align-center  ">
                  <Select
                    suffixIcon={
                      <DownOutlined
                        style={{
                          color: "#fff",
                          fontSize: 20,
                          fontWeight: "700",
                        }}
                      />
                    }
                    mode="multiple"
                    value={selectedPharmacies.slice().reverse()}
                    onChange={(values, options) => {
                      const pharmacies = options.map((opt) => opt.data);
                      updatePharmacies(values, pharmacies);
                    }}
                    allowClear={false}
                    className="w-full sm:w-auto custom-selectPhar"
                    dropdownClassName="custom-dropdown"
                    // placeholder="Select pharmacies"
                    showSearch={false}
                    virtual
                    // options={AllUser?.map((account, index) => ({
                    //   label: account.name || account.label,
                    //   value: account.acct_id,
                    //   key:
                    //     account.acct_id || `pharmacy-${account.value}-${index}`,
                    // }))}
                    options={AllUser?.map((account, index) => {
                      const modified = getDisplayPharmacy(account);
                      return {
                        label: modified.displayName,
                        value: account.acct_id, 
                        key: account.acct_id || `pharmacy-${index}`,
                        data: account, 
                      };
                    })}

                    loading={loading}
                    maxTagCount={1}
                    open={dropdownOpen}
                    onDropdownVisibleChange={(isOpen) => {
                      setDropdownOpen(isOpen);
                      if (!isOpen) setSearchText("");
                    }}
                    tagRender={({ label, value, closable, onClose }) => {
                      const showClose = selectedPharmacies.length > 1;
                      return (
                        <Tag
                          closable={showClose}
                          onClose={onClose}
                          style={{
                            width: "100%",
                            whiteSpace:
                              label?.length > 25 ? "normal" : "nowrap",
                            wordBreak: "break-word",
                            display: "inline-block",
                            lineHeight: "1.2",
                          }}
                          // className="bg-transparent text-[20px] font-bold border-none text-white rounded-lg px-4 py-2 text-center mx-auto max-w-[90%] sm:text-[26px] break-words whitespace-wrap xs:whitespace-nowrap"
                          className="bg-transparent text-[20px] font-bold border-none text-white rounded-lg px-4 py-2 text-center mx-auto sm:text-[26px]"
                        >
                          {/* <span className="break-words text-center">{label}</span> */}
                          {AllUser?.length > 0 && selectedPharmacies
                            ? label
                            : ""}
                          {/* { AllUser && AllUser.length > 0 && label
                            ? label
                            : 'NEW-MO-TOWN PHCY'} */}
                        </Tag>
                      );
                    }}
                    filterOption={false}
                    optionLabelProp="label"
                    dropdownRender={(menu) => (
                      <div>
                        {selectedPharmacies?.length > 0 && (
                          <div className="flex flex-wrap gap-1 p-2 pt-3">
                            {selectedPharmacies.map((id) => {
                              const pharmacy = AllUser.find(
                                (acc) => acc.acct_id === id
                              );
                              if (!pharmacy) return null;
                              const { displayName } = getDisplayPharmacy(pharmacy);
                              return (
                                <Tag
                                  key={id}
                                  closable
                                  onClose={() =>
                                    {
                                      const newIds = selectedPharmacies.filter((v) => v !== id);

                                      const pharmacies = AllUser.filter((acc) =>
                                        newIds.includes(acc.acct_id)
                                      );

                                      updatePharmacies(newIds, pharmacies);
                                    }
                                    // updatePharmacies(
                                    //   selectedPharmacies.filter((v) => v !== id)
                                    // )
                                  }
                                  className="flex items-center gap-1 px-2 py-0.5 border border-gray-300 rounded text-[10px] sm:text-[12px] text-black"
                                >
                                  {/* {pharmacy.name} */}
                                  {displayName}
                                </Tag>
                              );
                            })}
                          </div>
                        )}
                        <div className="flex justify-center px-2 py-2 border-b border-gray-200">
                          <div className="relative w-full">
                            <Input
                              placeholder="Search"
                              allowClear
                              value={searchText}
                              onChange={(e) => setSearchText(e.target.value)}
                              size="small"
                              onKeyDown={(e) => {
                                if (e.key === "Backspace") {
                                  e.stopPropagation();
                                }
                              }}
                              className="pr-6 text-xs rounded-sm bg-gray-100"
                            />
                            <SearchOutlined className="absolute top-1/2 right-2 -translate-y-1/2 text-gray-500 text-[12px]" />
                          </div>
                        </div>
                        <div className="max-h-60 overflow-y-auto px-2 sm:px-4 custom-scrollbar text-xs sm:text-sm max-w-100 w-full">
                          {filteredUsers.map((account) => {
                            const modified = getDisplayPharmacy(account);
                            const value = account.acct_id;
                            const label = `${modified.displayName.toUpperCase()} (${modified.displayId})`;
                            const isSelected =
                              selectedPharmacies.includes(value);
                            return (
                              <div
                                key={value}
                                className="flex items-center justify-around px-2 py-1 hover:bg-gray-100 rounded cursor-pointer w-full"
                                onMouseDown={(e) => e.preventDefault()}
                                onClick={() => {
                                  const newSelected = isSelected
                                    ? selectedPharmacies.filter(
                                        (id) => id !== value
                                      )
                                    : [...selectedPharmacies, value];
                                    const pharmacies = AllUser.filter((acc) =>
                                        newSelected.includes(acc?.acct_id)
                                      );
                                  updatePharmacies(newSelected, pharmacies);
                                }}
                              >
                                <div className="w-[15%]">
                                  <Checkbox checked={isSelected} />
                                </div>
                                <span className="w-[85%] text-[12px] sm:text-[13px] font-medium text-[#000833]">
                                  {label}
                                </span>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    )}
                  />
                </div>
              )}
              <div className="order-1 sm:order-2 w-full sm:w-auto flex justify-center">
                <img
                  src={applogo}
                  className="w-36 h-36 sm:w-36 sm:h-36 object-contain rounded"
                  alt="logo"
                />
              </div>

              <div className="order-3 w-full sm:w-auto flex flex-col justify-center sm:justify-end items-center gap-3">
                {/* <Select
                  className="custom-select text-base w-[1/2]"
                  style={{ width: 200, height: 45 }}
                  allowClear
                  value={selectedfilter}
                  onChange={handleChange}
                  disabled
                  options={[{ value: "month", label: "Monthly" }]}
                  placeholder="Month | Year"
                /> */}
                {/* <Select
                  className="custom-select text-base md:w-[250px] w-full h-[45px]"
                  // style={{ width: 280, height: 45 }}
                  suffixIcon={<DownOutlined style={{ color: "#fff" }} />}
                  // allowClear
                  value={selectedOption?.value}
                  onChange={handlemonth}
                  options={getHeaderdata[selectedfilter]
                    ?.slice()
                    .sort((a, b) => new Date(b.label) - new Date(a.label))
                    .map((item) => ({
                      value: item.value,
                      label: item.label,
                      key: item.key,
                    }))}
                  placeholder="Month | Year"
                /> */}
                  <DatePicker
                    picker="month"
                    onChange={onChangeMonth}
                    defaultValue={dayjs()}
                    value={selectedOption ? dayjs(selectedOption.label, "MMM YYYY") : dayjs()}
                    allowClear={false}
                    format="MMM YYYY"
                    disabledDate={disabledMonth}
                    inputReadOnly
                    className="brand-month-picker w-full md:w-[250px]"
                    dropdownClassName="brand-month-dropdown"
                    suffixIcon={<DownOutlined style={{ color: "#fff" }} />}
                  />
                  {
                  GCRPer?.latestInvoiceData?.invoiceDate && (
                    <div className="w-full md:w-[250px] rounded-md border border-[#4A5A7A] bg-[#1F2D4D]/90 px-1 py-2 shadow-lg">
                      <div className="text-[#fff] !text-[10px] md:text-base font-medium ml-2">
                        DATA RECEIVED THROUGH
                      </div>
                  
                      <div className="flex items-center gap-3 mt-1 ml-2">
                        <div className="w-2 h-2 rounded-full bg-green-400 shadow-[0_0_10px_rgba(74,222,128,0.8)]" />
                  
                        <span className="text-white text-md md:text-md font-bold text-[10px]">
                          {formatDate(GCRPer?.latestInvoiceData?.invoiceDate)}
                        </span>
                      </div>
                    </div>
                  )
                }
              </div>
            </div>
          )}
          <Row
            gutter={[24, 24]}
            className="flex flex-col sm:flex-row items-start -mb-1 sm:-mt-5"
            style={{alignItems:"stretch"}}
          >
            <Col xs={24} sm={12} md={12} className="w-full sm:w-1/2" style={{ display: 'flex', flexDirection: 'column' }}>
              <div className="card">
                <span className="title ">Quarterly Brand Economics</span>
                {userAuth?.user_roles_id == 5 ||
                userAuth?.user_roles_id == 1 ? (
                  <Button
                    className="mr-2 md:ml-10 "
                    onClick={() => setIsVisible(true)}
                  >
                    Projection Calculator
                  </Button>
                ) : null}
              </div>
              <div className="flex flex-wrap gap-5 w-full justify-start" style={{ flex: 1 }}>
                {[
                  {
                    title: "GCR (Quarter To Date)",
                    value: Number(GCRPer?.QTD_GCR_Percentage || 0).toFixed(2),
                    next: Number(GCRPer?.Next_QTD_GCR_Percentage || 0).toFixed(
                      2
                    ),
                    last: Number(GCRPer?.Last_QTD_GCR_Percentage || 0).toFixed(
                      2
                    ),
                    monthper: Number(GCRPer?.MTD_GCR_Percentage || 0).toFixed(
                      2
                    ),
                    projectedGCR: Number(GCRPer?.projectedQuarterlyGCR || 0).toFixed(
                      2
                    ),
                  },
                  {
                    title: "Trending COGs (Quarter To Date)",
                    value: Number(GCRPer?.QTD_COGS || 0).toFixed(2),
                    next: Number(GCRPer?.NEXT_QTD_COGS || 0).toFixed(2),
                    last: Number(GCRPer?.LAST_QTD_COGS || 0).toFixed(2),
                    cogs_impact: Number(GCRPer?.COGS_Impact).toFixed(2),
                  },
                ].map((item, idx) => (
                  <div key={idx} className="flex-1 min-w-[180px]" style={{ display: 'flex' }}>
                    <Card className="bg-[#DCF3FF] border-none cardAni h-full" style={{ width: '100%' }}>
                      <div className="flex flex-col justify-between h-full">
                        <div className="flex items-center gap-3 smallCardTitle mb-2 justify-between">
                          <span>{item.title}</span>
                          {/* <InfoCircleOutlined /> */}
                        { item.title === "GCR (Quarter To Date)"? <AntTooltip
                            placement="topRight"
                            color="transparent"
                            overlayInnerStyle={{
                              padding: 0,
                              boxShadow: "none", // ✅ shadow remove
                              background: "transparent",
                            }}
                            title={
                              <div className="w-[300px] md:w-[600px]">
                                <GCRTooltipTable data={quarterGcrPer} flag="Gcr"/>
                              </div>
                            }
                          >
                            <InfoCircleOutlined className="text-gray-500 hover:text-blue-600 cursor-pointer" />
                          </AntTooltip>
                          :
                           <AntTooltip
                            placement="topRight"
                            color="transparent"
                            overlayInnerStyle={{
                              padding: 0,
                              boxShadow: "none", // ✅ shadow remove
                              background: "transparent",
                            }}
                            title={
                              <div className="w-[300px] md:w-[600px]">
                                <GCRTooltipTable data={quarterGcrPer} />
                              </div>
                            }
                          >
                            <InfoCircleOutlined className="text-gray-500 hover:text-blue-600 cursor-pointer" />
                          </AntTooltip>
                          }
                        </div>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 6,
                          }}
                        >
                          <div
                            className={`font-jetbrains smallCarddata ${
                              animateValues ? "value-update" : ""
                            }`}
                          >
                            {item.value}%
                          </div>
                          {item?.title ===
                            "Trending COGs (Quarter To Date)" && apiVersion !== ""   && (
                            <span className="text-gray-700 ml-1">
                              | COGs Impact:{" "}
                              {item?.cogs_impact == "NaN" ||
                              item?.cogs_impact === undefined ||
                              isLoading ? (
                                <Spin
                                  indicator={<LoadingOutlined spin />}
                                  size="10"
                                  className="text-[#15033f] "
                                />
                              ) : (
                                <span
                                  className={
                                    item?.cogs_impact < 0
                                      ? "text-red-500"
                                      : "text-green-500"
                                  }
                                >
                                  $ {item?.cogs_impact}
                                </span>
                              )}
                            </span>
                          )}
                        </div>
                        {item?.title === "GCR (Quarter To Date)" &&(
                        <span className="text-gray-700 mt-3">
                          {item?.next >= 12 ? "Top Tier" : "Next Tier" }: {item?.next} %
                        </span>
                        )}
                        {item?.title === "Trending COGs (Quarter To Date)" &&(
                        <span className="text-gray-700 mt-3">
                          {item?.next >= 5.75 ? "Top Tier" : "Next Tier" }: {item?.next} %
                        </span>
                        )}
                        <span className="text-gray-700">
                          {/* Last Period: {item.last} % */}
                          {item.title === "Trending COGs (Quarter To Date)"
                            ? "Current COGS"
                            : "Last Period"}
                          : {item.last} %
                        </span>

                        {item?.monthper !== undefined ? (
                          <span className="text-gray-700">
                            MTD : {item?.monthper} %
                          </span>
                        ) : null}
                      </div>
                      {item?.title === "GCR (Quarter To Date)" && (
                        <div
                          className="text-[#000833]"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 4,
                            fontSize: 16,
                            fontWeight: "600",
                            justifyContent:'space-between'
                          }}
                        >
                          <div>
                          {/* Target: {Number(quarterGCRTarget)?.toFixed(2) || 0.00} % */}
                          Target: {getQuarterTarget(item,quarterGcrPer,quarterGCRTarget,setQuarterGCRTarget)} %
                          {isSelectedCurrentMonth() && userAuth?.user_roles_id === 5 && (
                            <EditOutlined
                              onClick={() =>
                                handleTarget("Quarter_GCR", item?.value)
                              }
                              className="font-jetbrains text-[#000833]"
                              style={{ fontSize: 16, cursor: "pointer" }}
                            />
                          )}
                           </div>
                           {
                            (quarterGCRTarget !==0 && quarterGCRTarget !=="") && (
                            <AntTooltip
                              placement="top"
                              color="white"
                              getPopupContainer={() => document.body}
                              overlayStyle={{ maxWidth: "none" }}
                              overlayInnerStyle={{
                                padding: 0,
                                boxShadow: "none",
                                background: "transparent",
                              }}
                              title={
                                <div className="w-[300px] md:w-[600px]">
                                  <QuarterTargetTable data={QuarterTableData} />
                                </div>
                              }
                            >
                              <InfoCircleOutlined className="text-gray-500 hover:text-blue-600 cursor-pointer" />
                            </AntTooltip>
                            )
                           }
                        </div>
                      )}
                      {/* |  */}
                      {/* <div className="flex flex-col justify-between h-full">
                        <div className="flex items-center justify-between mb-2 smallCardTitle">
                          <span>{item.title}</span>
                          <InfoCircleOutlined />
                        </div>
                        <div className={`font-jetbrains smallCarddata ${animateValues ? "value-update" : ""}`}>
                          {item.value}%
                        </div>
                        <div className="flex justify-between text-sm text-gray-700 mt-3">
                          <div className="flex flex-col gap-1">
                            <span>Next: {item.next} %</span>
                            <span>Last Period: {item.last} %</span>
                          </div>
                          {item?.monthper !== undefined && (
                            <div className="flex flex-col gap-1 self-end -mt-1">
                              <span className="font-medium text-gray-600">Month to Date</span>
                              <span className="font-bold text-black text-base">GCR: {item.monthper}%</span>
                            </div>
                          )}
                        </div>
                      </div> */}
                    </Card>
                  </div>
                ))}
              </div>
            </Col>

            <Col xs={24} sm={12} md={12} className="w-full sm:w-1/2" style={{ display: 'flex', flexDirection: 'column' }}>
              <div className="card">
                <span className="title">Monthly Brand Rebates</span>
              </div>
              <div className="flex flex-wrap gap-5 w-full justify-start" style={{ flex: 1 }}>
                {[
                  {
                    title: "Scrubbed GCR",
                    value: Number(GCRPer?.MON_SGCR_Percentage || 0).toFixed(2),
                    next: Number(GCRPer?.Next_MON_SGCR_Percentage || 0).toFixed(
                      2
                    ),
                    last: Number(GCRPer?.Last_MON_SGCR_Percentage || 0).toFixed(
                      2
                    ),
                    isTopTier: GCRPer?.isTopTier,
                  },
                  {
                    title: "GPR (Monthly)",
                    value: Number(GCRPer?.GPR_Percentage || 0).toFixed(2),
                    // value: Number(
                    //   GCRPer?.GPR_Percentage === '0.00' || GCRPer?.GPR_Percentage == null
                    //     ? 75
                    //     : GCRPer.GPR_Percentage
                    // ).toFixed(2),
                    next: Number(GCRPer?.NEXT_GPR_Percentage || 0).toFixed(2),
                    last: Number(GCRPer?.LAST_GPR_Percentage || 0).toFixed(2),
                    date: GCRPer?.isValidReportingDate
                      ? formatMonthYear(GCRPer?.GPR_Reporting_Period)
                      : "",
                    isTopTier: GCRPer?.isTopTier,
                  },
                  {
                    title: "Total Brand Rebate",
                    value: Number(GCRPer?.brand_total_rebate || 0).toFixed(2),
                    next: Number(GCRPer?.nextBrandRebateTotal || 0).toFixed(2),
                    last: Number(GCRPer?.lastBrandRebateTotal || 0).toFixed(2),
                    isTopTier: GCRPer?.isTopTier,
                  },
                ].map((item, idx) => (
                  <div key={idx} className="flex-1 min-w-[150px]" style={{ display: 'flex' }}>
                    <Card className="bg-[#DCF3FF] border-none cardAni h-full" style={{ width: '100%' }}>
                      <div className="flex flex-col justify-between h-full">
                        <div className="flex items-center gap-3 smallCardTitle mb-2 justify-between">
                          {item?.title === "GPR (Monthly)" ? (
                            <span>
                              {item?.title.replace(/\s*\(.*?\)/, "")}{" "}
                              {item?.date ? `(${item?.date})` : ""}
                            </span>
                          ) : (
                            <span>{item?.title}</span>
                          )}
                          {item?.title === "Scrubbed GCR" ? (
                            <AntTooltip
                              placement="top"
                              color="transparent"
                              overlayInnerStyle={{
                                padding: 0,
                                boxShadow: "none", // ✅ shadow remove
                                background: "transparent",
                              }}
                              title={
                                <div className="w-[300px] md:w-[600px]">
                                  <SGCRTooltipTable data={monthSgcrPer} flag="SGCR"/>
                                </div>
                              }
                            >
                              <InfoCircleOutlined className="text-gray-500 hover:text-blue-600 cursor-pointer" />
                            </AntTooltip>
                          ) : item?.title === "GPR (Monthly)" ? (
                            <AntTooltip
                              placement="top"
                              color="white"
                              getPopupContainer={() => document.body}
                              overlayStyle={{ maxWidth: "none" }}
                              overlayInnerStyle={{
                                padding: 0,
                                boxShadow: "none",
                                background: "transparent",
                              }}
                              title={
                                <div className="w-[300px] md:w-[400px]">
                                  <GPRTooltipTable data={monthGprPer} flag="GPR"/>
                                  <div className="px-3 flex items-center justify-center text-sm text-blue-600 bg-white pb-3 rounded-md my-5">
                                    Reach out to AAPA to gain access to more
                                    rebates
                                  </div>
                                </div>
                              }
                            >
                              <InfoCircleOutlined className="text-gray-500 hover:text-blue-600 cursor-pointer" />
                            </AntTooltip>
                          ) : (
                            <InfoCircleOutlined />
                          )}
                        </div>
                        {/* <div style={{ display: "flex", alignItems: "center",marginRight:-10  }}> */}

                        <div
                          className={` font-jetbrains smallCarddata ${animateValues ? "value-update" : ""
                          }`}
                        >
                          {item.value}%
                        </div>

                        {/* </div> */}

                        {item.title !== "Total Brand Rebate" ? (
                          <span className="text-gray-700 mt-3">
                            {item.title === "GPR (Monthly)"
                              ? item?.isTopTier
                                ? "Top Tier"
                                : "Next Tier"
                              : item?.next >= 20 ? "Top Tier" : "Next Tier"}
                            : {item.title === "GPR (Monthly)" && item?.next >= 90 ? "90.00 %" : `${item?.next} %`} 
                          </span>
                        ) : (
                          <span className="text-gray-700 invisible">
                            {item?.isTopTier ? "Top Tier" : "Next Tier"}: 0.00 %
                          </span>
                        )}
                        <span className="text-gray-700">
                          Last Period: {item?.last} %
                        </span>
                        {item?.title === "Scrubbed GCR" && (
                          <div
                            className="text-[#000833]"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 4,
                              fontSize: 15,
                              fontWeight: "600",
                              justifyContent:"space-between"
                            }}
                          >
                            <div className="w-[73%] sm:w-[100%] md:w-auto ">
                            {/* Target: {Number(SGCRTarget)?.toFixed(2) || 0.00} % */}
                             Target: {getQuarterTarget(item,monthSgcrPer,SGCRTarget,setSGCRTarget)} %
                            {isSelectedCurrentMonth() && userAuth?.user_roles_id === 5 && (
                              <EditOutlined
                                onClick={() =>
                                  handleTarget("Month_SGCR", item?.value)
                                }
                                className="text-[#000833]"
                                style={{ fontSize: 16, cursor: "pointer" }}
                              />
                            )}
                            </div>
                            {
                            (SGCRTarget !== 0 && SGCRTarget !=="") && (
                            <AntTooltip
                              placement="top"
                              color="white"
                              getPopupContainer={() => document.body}
                              overlayStyle={{ maxWidth: "none" }}
                              overlayInnerStyle={{
                                padding: 0,
                                boxShadow: "none",
                                background: "transparent",
                              }}
                              title={
                                <div className="w-[300px] md:w-[600px]">
                                  <SGCRTargetTable data={SgcrTableData} />
                                </div>
                              }
                            >
                              <InfoCircleOutlined className="text-gray-500 hover:text-blue-600 cursor-pointer" />
                            </AntTooltip>
                            )}
                          </div>
                        )}
                        {item?.title === "GPR (Monthly)" && (
                          <div className="flex flex-row justify-between">
                          <div
                            className="text-[#000833]"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 4,
                              fontSize: 16,
                              fontWeight: "600",
                              // justifyContent:"space-between"
                            }}
                          >
                            {/* Target: {Number(GPRTarget)?.toFixed(2) || 0.00} % */}
                            Target: {getGPRTarget(item,monthGprPer,GPRTarget)} %
                            {isSelectedCurrentMonth() && userAuth?.user_roles_id === 5 && (
                              <EditOutlined
                                className="text-[#000833]"
                                onClick={() =>
                                  handleTarget("Month_GPR", item?.value)
                                }
                                style={{ fontSize: 16, cursor: "pointer" }}
                              />
                            )}
                            </div>
                           {/* <AntTooltip
                              placement="top"
                              color="white"
                              getPopupContainer={() => document.body}
                              overlayStyle={{ maxWidth: "none" }}
                              overlayInnerStyle={{
                                padding: 0,
                                boxShadow: "none",
                                background: "transparent",
                              }}
                              title={
                                <div className="min-w-[200px] max-w-[400px]">
                                  <GPRTooltipTable data={monthGprPer} />
                                  <div className="px-3 flex items-center justify-center text-sm text-blue-600 bg-white pb-3 rounded-md">
                                    Reach out to AAPA to gain access to more
                                    rebates
                                  </div>
                                </div>
                              }
                            >
                              <InfoCircleOutlined className="text-gray-500 hover:text-blue-600 cursor-pointer" />
                            </AntTooltip> */}
                         </div>
                        )}

                        {/* | */}
                        {/* <span className="invisible">0.00%</span> */}
                      </div>
                    </Card>
                  </div>
                ))}
              </div>
            </Col>
          </Row>
          {/* {admin && !adminChatBot && (
        <div className="chat-button" onClick={() => navigate('/admin-chat')}>
          💬 Let’s Chat Admin
        </div>
      )} */}
          {/* {userAuth?.email !== "anuja@grapetech.ae" && !chatBoxOpen && (
            <div className="chat-button" onClick={() => setChatOpen(true)}>
              💬 Let’s Chat
            </div>
          )} */}
        </Content>

        {/* <Layout className="min-h-screen bg-[#000B40]"> */}
        <Content className="min-h-screen sm:p-4 sm:pt-0 pt-4">
          {!isLoading && (
            <>
              <div className="bg-[#efecfc] p-4 border border-blue-300 rounded-md shadow-md w-full mx-auto -mt-3">
                {/* Header */}
                <div className="flex items-center justify-between mb-4">
                  <h2 className="font-semibold text-lg">
                    Monthly Rebate Program
                  </h2>
                  <div className="flex items-center gap-2 text-gray-600 text-lg">
                    <InfoCircleOutlined />
                    <EllipsisOutlined />
                  </div>
                </div>

                {/* Cards Section */}
                <div className="  flex flex-wrap justify-between gap-4">
                  {/* Total Rebate */}
                  <div className="bg-[#efecfc] rounded-md p-4 w-full sm:w-[32%]">
                    <div className="bg-[#c5b8ff] text-sm px-2 py-1 rounded-md font-bold">
                      Total Rebate
                    </div>
                    <div className="text-2xl font-bold mb-3 px-2 py-1 bg-[#ded7fd] font-jetbrains">
                      {/* $ {(isNaN(Number(GCRPer?.total_rebate_value)) ? 0 : Number(GCRPer.total_rebate_value)).toFixed(2)} */}
                      ${" "}
                      {(isNaN(Number(GCRPer?.total_rebate_value))
                        ? 0
                        : Number(GCRPer.total_rebate_value)
                      ).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </div>
                    <div className="text-sm text-gray-700 leading-6">
                      <div className="flex">
                        <div className="w-1 h-6 rounded-full bg-purple-300 mr-2"></div>
                        <p className="block font-bold">
                          OneStop Generic Rebate :{" "}
                        </p>
                        <span className="ml-2">
                          {" "}
                          ${" "}
                          {Number(
                            GCRPer?.one_stop_rebate_value || 0
                          ).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </span>
                      </div>
                      <div className="flex mt-3">
                        <div className="w-1 h-6 rounded-full bg-purple-300 mr-2"></div>
                        <p className="block font-bold">Brand Rebate:</p>
                        <span className="ml-2">
                          {" "}
                          ${" "}
                          {Number(
                            GCRPer?.brand_rebate_value || 0
                          ).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* OneStop Rebate */}
                  <div className="bg-[#efecfc] rounded-md p-4 w-full sm:w-[32%]">
                    <div className="bg-[#c5b8ff] text-sm px-2 py-1 rounded-md font-bold">
                      OneStop Rebate Program
                    </div>
                    <div className="text-2xl font-bold mb-3 bg-[#ded7fd] px-2 py-1 font-jetbrains">
                      ${" "}
                      {Number(
                        GCRPer?.one_stop_rebate_value || 0
                      ).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </div>
                    <div className="text-sm text-gray-700 space-y-1">
                      <div className="flex gap-2 items-center">
                        <div className="w-1 h-6 rounded-full bg-purple-300 "></div>
                        <span className="font-bold">Rebate:</span>
                        <span className="bg-[#ded7fd] text-xs px-2 py-0.5 rounded border border-gray-300">
                          SGCR:{" "}
                          {Number(GCRPer?.one_stop_sgcr_rebate || 0).toFixed(2)}
                          %
                        </span>
                        <span className="bg-[#ded7fd] text-xs px-2 py-0.5 rounded border border-gray-300">
                          GPR:{" "}
                          {Number(GCRPer?.one_stop_gpr_rebate || 0).toFixed(2)}%
                        </span>
                        <span className="bg-[#ded7fd] text-xs px-2 py-0.5 rounded border border-gray-300">
                          Total:{" "}
                          {Number(GCRPer?.one_stop_total_rebate || 0).toFixed(
                            2
                          )}
                          %
                        </span>
                      </div>
                      <div className="flex mt-3">
                        <div className="w-1 h-6 rounded-full bg-purple-300 mr-2"></div>
                        <p className="font-bold mt-[8px]">OneStop Rx Total:</p>
                        <span className="bg-[#ded7fd] text-xs px-2 py-0.5 rounded border border-gray-300 mt-[8px] ml-2">
                          {" "}
                          ${" "}
                          {Number(
                            GCRPer?.raw_data?.Rebatable_OneStop_Rx || 0
                          ).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Brand Rebate */}
                  <div className="bg-[#efecfc] rounded-md p-4 w-full sm:w-[32%]">
                    <div className="bg-[#c5b8ff] text-sm px-2 py-1 rounded-md font-bold">
                      Brand Rebate
                    </div>
                    <div className="text-2xl font-bold mb-3 bg-[#ded7fd] px-2 py-1 font-jetbrains">
                      ${" "}
                      {Number(GCRPer?.brand_rebate_value || 0).toLocaleString(
                        undefined,
                        { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                      )}
                    </div>
                    <div className="text-sm text-gray-700 space-y-1">
                      <div className="flex gap-2 items-center">
                        <div className="w-1 h-6 rounded-full bg-purple-300"></div>
                        <span className="font-bold">Rebate:</span>
                        <span className="bg-[#ded7fd] text-xs px-2 py-0.5 rounded border border-gray-300">
                          SGCR:{" "}
                          {Number(GCRPer?.brand_sgcr_rebate || 0).toFixed(2)}%
                        </span>
                        <span className="bg-[#ded7fd] text-xs px-2 py-0.5 rounded border border-gray-300">
                          GPR:{" "}
                          {Number(GCRPer?.brand_gpr_rebate || 0).toFixed(2)}%
                        </span>
                        <span className="bg-[#ded7fd] text-xs px-2 py-0.5 rounded border border-gray-300">
                          Total:{" "}
                          {Number(GCRPer?.brand_total_rebate || 0).toFixed(2)}%
                        </span>
                      </div>
                      <div className="flex mt-3">
                        <div className="w-1 h-6 rounded-full bg-purple-300 mr-2"></div>
                        <p className="font-bold mt-[8px]">
                          Rebatable Brand Total:
                        </p>{" "}
                        <span className="bg-[#ded7fd] text-xs px-2 py-0.5 rounded border border-gray-300 mt-[8px] ml-2">
                          ${" "}
                          {Number(
                            GCRPer?.raw_data?.Rebatable_Brand_Rx || 0
                          ).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <Row gutter={[16, 16]} className="mb-8 mt-5">
                <Col xs={24} md={12}>
                  <Card
                    title={
                      <div className="flex justify-between items-center">
                        <span className="cardtitle">Performance Scorecard</span>
                        <div className="flex items-center gap-4">
                          {/* <Segmented
                            options={["Current Period", "Previous Period"]}
                            value={activePeriod === "current" ? "Current Period" : "Previous Period"}
                            onChange={(val) => setActivePeriod(val === "Current Period" ? "current" : "previous")}
                            className="custom-segmented"
                          /> */}
                          <div className="-mr-1">
                            <InfoCircleOutlined className="mr-2" />
                            <MoreOutlined />
                          </div>
                        </div>
                      </div>
                    }
                    className="bg-white h-full CardShadow cardAni tableCard-Custom"
                  >
                    <div className="flex mx-2">
                      <Tabs
                        activeKey={activePeriod}
                        onChange={(key) => setActivePeriod(key)}
                        className="custom-tabs w-full"
                        centered={true}
                      >
                        <TabPane tab="Current Period" key="current" />
                        <TabPane tab="Previous Period" key="previous" />
                      </Tabs>
                    </div>


                    {activePeriod == "current" ? (
                      <>
                        <div className="w-full overflow-x-auto scrollbar-hide">
                          <div className="min-w-[600px]">
                            <div className="performance-table">
                              <div className=" row flex flex-wrap sm:flex-nowrap align-middle ">
                                <span className=" col metric w-full sm:w-1/3 font-bold">
                                  Metric
                                </span>
                                <span className="col right w-full sm:w-1/3 text-right font-bold ">
                                  {GCRPer?.raw_data?.month
                                    ? `MTD (${formatMonthLabel(
                                        GCRPer.raw_data?.month
                                      )})`
                                    : "MTD"}{" "}
                                  $
                                </span>
                                <span className="col right w-full sm:w-1/3 text-right font-bold  ">
                                  {GCRPer?.raw_quarter_data?.quarter
                                    ? `QTD (${formatQuarterLabel(
                                        GCRPer?.raw_quarter_data?.quarter
                                      )})`
                                    : "QTD"}{" "}
                                  $
                                </span>
                              </div>

                              <div className="row total flex flex-wrap sm:flex-nowrap">
                                <div
                                  className=" col metric w-full sm:w-1/3  text-2xl"
                                  style={{
                                    fontFamily: "Nunito Sans",
                                    fontWeight: "800",
                                  }}
                                >
                                  Total Rx
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right  text-2xl font-bold font-jetbrains">
                                  {Number(
                                    GCRPer?.raw_data?.Total_Rx || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right    text-2xl font-bold font-jetbrains">
                                  {Number(
                                    GCRPer?.raw_quarter_data?.Total_Rx || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                              </div>

                              <div className="row section-header  flex flex-wrap sm:flex-nowrap">
                                <div className=" col metric w-full sm:w-1/3 font-bold">
                                  Generic RX
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right font-bold">
                                  {Number(
                                    GCRPer?.raw_data?.Generic_Rx || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right font-bold">
                                  {Number(
                                    GCRPer?.raw_quarter_data?.Generic_Rx || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                              </div>
                              <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                                <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                                  OneStop Rx
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.raw_data?.OnStop_Generic || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.raw_quarter_data?.OnStop_Generic ||
                                      0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                              </div>
                              <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                                <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                                  RTL 2
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.raw_data?.RTL2_Rx || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.raw_quarter_data?.RTL2_Rx ||
                                    0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                              </div>

                              <div className="row section-header mt-5  flex flex-wrap sm:flex-nowrap">
                                <div className=" col metric w-full sm:w-1/3 font-bold">
                                  Brand RX
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right font-bold">
                                  {Number(
                                    GCRPer?.raw_data?.Brand_Rx || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right font-bold">
                                  {Number(
                                    GCRPer?.raw_quarter_data?.Brand_Rx || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                              </div>

                              <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                                <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                                  Rebatable Brand
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.raw_data?.Rebatable_Brand_Rx || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.raw_quarter_data
                                      ?.Rebatable_Brand_Rx || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                              </div>

                              <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                                <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                                  GLP1
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.raw_data?.GLP1 || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.raw_quarter_data?.GLP1 || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                              </div>
                              <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                                <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                                  HIV
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.raw_data?.HIV_Sum || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.raw_quarter_data?.HIV_Sum || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                              </div>
                              <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                                <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                                  Speciality (incl. HIV)
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.raw_data?.Specialty || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.raw_quarter_data?.Specialty || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                              </div>
                              <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                                <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                                  Flu + COVID
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.raw_data?.totalFluCovid || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.raw_quarter_data?.totalFluCovid || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                              </div>
                              <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                                <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                                  Biosim
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.raw_data?.totalBiosim || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.raw_quarter_data?.totalBiosim || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                              </div>
                              {/* {
                                apiVersion !== "" &&
                              (
                              <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                                <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                                  MTF Drug
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.raw_data?.totalMTF_Drug || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.raw_quarter_data?.totalMTF_Drug || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                              </div>
                                )
                              } */}

                            </div>
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="w-full overflow-x-auto scrollbar-hide">
                          <div className="min-w-[600px]">
                            <div className="performance-table">
                              <div className=" row flex flex-wrap sm:flex-nowrap align-middle ">
                                <span className=" col metric w-full sm:w-1/3 font-bold">
                                  Metric
                                </span>
                                <span className="col right w-full sm:w-1/3 text-right font-bold ">
                                  {GCRPer?.lastMetrics?.month
                                    ? `MTD (${formatMonthLabel(
                                        GCRPer?.lastMetrics?.month
                                      )})`
                                    : "MTD"}{" "}
                                  $
                                </span>
                                <span className="col right w-full sm:w-1/3 text-right font-bold  ">
                                  {GCRPer?.last_quarter_Metrics?.quarter
                                    ? `QTD (${formatQuarterLabel(
                                        GCRPer?.last_quarter_Metrics?.quarter
                                      )})`
                                    : "QTD"}{" "}
                                  $
                                </span>
                              </div>

                              <div className="row total flex flex-wrap sm:flex-nowrap">
                                <div
                                  className=" col metric w-full sm:w-1/3  text-2xl"
                                  style={{
                                    fontFamily: "Nunito Sans",
                                    fontWeight: "800",
                                  }}
                                >
                                  Total Rx
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right  text-2xl font-bold font-jetbrains">
                                  {Number(
                                    GCRPer?.lastMetrics?.Total_Rx || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right    text-2xl font-bold font-jetbrains">
                                  {Number(
                                    GCRPer?.last_quarter_Metrics?.Total_Rx || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                              </div>

                              <div className="row section-header  flex flex-wrap sm:flex-nowrap">
                                <div className=" col metric w-full sm:w-1/3 font-bold">
                                  Generic RX
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right font-bold">
                                  {Number(
                                    GCRPer?.lastMetrics?.Generic_Rx || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right font-bold">
                                  {Number(
                                    GCRPer?.last_quarter_Metrics?.Generic_Rx ||
                                      0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                              </div>
                              <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                                <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                                  OneStop Rx
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.lastMetrics?.OnStop_Generic || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.last_quarter_Metrics
                                      ?.OnStop_Generic || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                              </div>

                              <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                                <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                                  RTL 2
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.lastMetrics?.RTL2_Rx || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.last_quarter_Metrics
                                      ?.RTL2_Rx || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                              </div>

                              <div className="row section-header mt-5  flex flex-wrap sm:flex-nowrap">
                                <div className=" col metric w-full sm:w-1/3 font-bold">
                                  Brand RX
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right font-bold">
                                  {Number(
                                    GCRPer?.lastMetrics?.Brand_Rx || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right font-bold">
                                  {Number(
                                    GCRPer?.last_quarter_Metrics?.Brand_Rx || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                              </div>

                              <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                                <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                                  Rebatable Brand
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.lastMetrics?.Rebatable_Brand_Rx || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.last_quarter_Metrics
                                      ?.Rebatable_Brand_Rx || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                              </div>

                              <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                                <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                                  GLP1
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.lastMetrics?.GLP1 || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.last_quarter_Metrics?.GLP1 || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                              </div>
                              <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                                <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                                  HIV
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.lastMetrics?.HIV_Sum || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.last_quarter_Metrics?.HIV_Sum || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                              </div>
                              <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                                <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                                  Speciality (incl. HIV)
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.lastMetrics?.Specialty || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.last_quarter_Metrics?.Specialty || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                              </div>
                              <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                                <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                                  Flu + COVID
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.lastMetrics?.totalFluCovid || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.last_quarter_Metrics
                                      ?.totalFluCovid || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                              </div>
                              <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                                <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                                  Biosim
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.lastMetrics?.totalBiosim || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.last_quarter_Metrics?.totalBiosim ||
                                      0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                              </div>
                                  
                              {/* {
                                apiVersion !== "" && (
                                  <>
                              <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                                <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                                  MTF Drug
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.lastMetrics?.totalMTF_Drug || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.last_quarter_Metrics?.totalMTF_Drug || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                              </div>
                              {
                                isBeforeOrEqualMarch2026 &&
                                <>
                            <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                                <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                                  Projected MTF Drug
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.lastMetrics?.projected_mtf_drug || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.last_quarter_Metrics?.projected_mtf_drug || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                              </div>
                              
                               <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                                <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                                  WAC Dollar Impact
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.lastMetrics?.wac_dollar_impact || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.last_quarter_Metrics?.wac_dollar_impact || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                              </div>
                              </>
                              }
                              </>
                            )} */}

                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </Card>
                </Col>

                <Col xs={24} md={12}>
                  <Card
                    title={
                      <div className="flex justify-between items-center">
                        <div className="cardtitle mb-1">
                          Trailing Monthly Rebate Performance
                        </div>
                        <div className="flex items-center gap-2 cardtitle2">
                          <div className="-mr-1">
                            <InfoCircleOutlined className="mr-2" />
                            <MoreOutlined />
                          </div>
                        </div>
                      </div>
                    }
                    className="bg-white h-full CardShadow cardAni"
                  >
                    <div className="w-full overflow-x-auto scrollbar-hide">
                      <div className="min-w-[590px]">
                        <ResponsiveContainer width="100%" aspect={1}>
                          <BarChart
                            data={processedRebateData}
                            barSize={50}
                            barGap={2}
                            barCategoryGap="10%"
                            margin={{ top: 0, right: 0, left: 0, bottom: 0 }}
                          >
                            <defs>
                              <pattern
                                id="patternGPR"
                                patternUnits="userSpaceOnUse"
                                width="10"
                                height="10"
                              >
                                <rect width="10" height="10" fill="#0B9CE9" />
                                <path
                                  d="M0,10 l10,-10 M-2,2 l4,-4 M8,12 l4,-4"
                                  stroke="rgba(255,255,255,0.2)"
                                  strokeWidth="4"
                                />
                              </pattern>
                              <pattern
                                id="patternGCR"
                                patternUnits="userSpaceOnUse"
                                width="10"
                                height="10"
                              >
                                <rect width="10" height="10" fill="#001997" />
                                <path
                                  d="M0,10 l10,-10"
                                  stroke="rgba(255,255,255,0.2)"
                                  strokeWidth="4"
                                />
                              </pattern>
                              <pattern
                                id="patternSGPR"
                                patternUnits="userSpaceOnUse"
                                width="10"
                                height="10"
                              >
                                <rect width="10" height="10" fill="#FF9635" />
                                <path
                                  d="M0,10 l10,-10"
                                  stroke="rgba(255,255,255,0.2)"
                                  strokeWidth="4"
                                />
                              </pattern>
                              <pattern
                                id="patternSGCR"
                                patternUnits="userSpaceOnUse"
                                width="10"
                                height="10"
                              >
                                <rect width="10" height="10" fill="#009767" />
                                <path
                                  d="M0,10 l10,-10"
                                  stroke="rgba(255,255,255,0.2)"
                                  strokeWidth="4"
                                />
                              </pattern>
                            </defs>

                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="month" />
                            <YAxis
                              tickFormatter={(value) =>
                                `$${(value / 1000).toFixed(0)}k`
                              }
                            />
                            <Tooltip
                              formatter={(value) =>
                                `$${value.toLocaleString()}`
                              }
                            />
                            <Legend />
                            <Bar
                              dataKey="Brand_Rebate_GPR_Value"
                              stackId="a"
                              fill="url(#patternGPR)"
                              name="Brand Rebate GPR"
                            />
                            <Bar
                              dataKey="Brand_Rebate_SGCR_Value"
                              stackId="a"
                              fill="url(#patternGCR)"
                              name="Brand Rebate SGCR"
                            />
                            <Bar
                              dataKey="OneStop_Rebate_GPR_value"
                              stackId="a"
                              fill="url(#patternSGPR)"
                              name="One Stop Rebate GPR"
                            />
                            <Bar
                              dataKey="OneStop_Rebate_SGCR_value"
                              stackId="a"
                              fill="url(#patternSGCR)"
                              name="One Stop Rebate SGCR"
                            />
                          </BarChart>
                        </ResponsiveContainer>
                      </div>
                    </div>
                  </Card>
                </Col>
              </Row>
              {/* // Add this section after the Performance Scorecard and Estimated Program Rebate */}
              <Row gutter={[16, 16]} className="mb-8">
                <Col xs={24} md={12}>
                  <Card
                    title={
                      <div className="flex justify-between items-center">
                        <div className="cardtitle">GPR Trailing Data</div>
                        <div className="-mr-1">
                          <InfoCircleOutlined className="mr-2" />
                          <MoreOutlined />
                        </div>
                      </div>
                    }
                    className="bg-white h-full CardShadow cardAni"
                    // bodyStyle={{ padding: 5 }}
                  >
                    <div className="w-full overflow-x-auto scrollbar-hide">
                      <div className="min-w-[600px]">
                        <ResponsiveContainer width="100%" height={500}>
                          <BarChart
                            data={TrailingData ? TrailingData.slice(-6) : []}
                            barGap={10}
                            barSize={30}
                            margin={{ top: 5, right: 5, left: 30, bottom: 40 }} // Increased bottom for X label
                          >
                            <defs>
                              <pattern
                                id="patternGPR"
                                patternUnits="userSpaceOnUse"
                                width="10"
                                height="10"
                              >
                                <rect width="10" height="10" fill="#A5D6F3" />
                                <path
                                  d="M0,10 l10,-10"
                                  stroke="rgba(255,255,255,0.3)"
                                  strokeWidth="4"
                                />
                              </pattern>

                              <pattern
                                id="patternGPRDark"
                                patternUnits="userSpaceOnUse"
                                width="10"
                                height="10"
                              >
                                <rect width="10" height="10" fill="#033d61ff" />{" "}
                                {/* Darker shade */}
                                <path
                                  d="M0,10 l10,-10"
                                  stroke="rgba(255,255,255,0.3)"
                                  strokeWidth="4"
                                />
                              </pattern>
                            </defs>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis
                              dataKey="period"
                              tick={{
                                fontSize: 12,
                                fill: "#000833",
                                fontWeight: 600,
                                fontFamily: "Nunito Sans",
                              }}
                              label={{
                                value: "Months",
                                position: "bottom",
                                dy: 20,
                                style: {
                                  textAnchor: "middle",
                                  fill: "#000833",
                                  fontSize: 14,
                                  fontWeight: 700,
                                  fontFamily: "Nunito Sans",
                                },
                              }}
                            />

                            <YAxis
                              domain={[0, 120]} // Set based on your data max rounded to next 10
                              // ticks={[
                              //   0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110,
                              //   120,
                              // ]} // Explicit tick steps
                              ticks={[...Array(25)].map((_, i) => i * 5)}
                              tick={{
                                fill: "#000833",
                                fontWeight: 600,
                                fontFamily: "Nunito Sans",
                                fontSize: 12,
                              }}
                              label={{
                                value: "GPR, % (Average)",
                                angle: -90,
                                // position: 'insideLeft',
                                dx: -20,
                                style: {
                                  fontWeight: 700,
                                  fill: "#1d2330",
                                  fontSize: 14,
                                  fontFamily: "Nunito Sans",
                                },
                              }}
                            />
                            <Tooltip
                              formatter={(value) => [
                                `${value.toFixed(2)}%`,
                                "Monthly GPR",
                              ]}
                            />
                            <Legend
                              verticalAlign="top"
                              align="center"
                              height={30}
                              wrapperStyle={{
                                fontWeight: 600,
                                fontFamily: "Nunito Sans",
                                fontSize: 14,
                                color: "#000833",
                              }}
                            />

                            {/* <Bar
                              dataKey="per_month_gpr"
                              name="Monthly GPR"
                              fill="url(#patternGPR)"
                              radius={[4, 4, 0, 0]}
                            /> */}

                            <Bar
                              dataKey="avg_3_month"
                              name="3 Month GPR"
                              fill="url(#patternGPR)"
                              radius={[4, 4, 0, 0]}
                            />

                            <Bar
                              dataKey="avg_6_month"
                              name="6 Month GPR"
                              fill="url(#patternGPRDark)"
                              radius={[4, 4, 0, 0]}
                            />
                          </BarChart>
                        </ResponsiveContainer>
                      </div>
                    </div>
                  </Card>
                </Col>
                <Col xs={24} md={12}>
                  <Card
                    title={
                      <div className="flex justify-between items-center">
                        <span className="cardtitle">
                          Top RX Generic Purchase (Positive Impact)
                        </span>
                        <div className="-mr-1">
                          <InfoCircleOutlined
                            className="mr-2 cursor-pointer"
                            onClick={() => navigate("/data_table_gcr")}
                          />
                          <MoreOutlined />
                        </div>
                      </div>
                    }
                    className="bg-white h-full CardShadow cardAni tableCard-Custom"
                  >
                    <div
                      className="overflow-x-auto  scrollbar-hide"
                      style={{ maxWidth: "100%" }}
                    >
                      <Table
                        className="border-table"
                        style={{ marginTop: "-20px", minWidth: "600px" }}
                        dataSource={TopRxSpentSQL.map((item, index) => ({
                          ...item,
                          key: `rx-${item.drug_name}-${index}` || `rx-${index}`,
                        }))}
                        pagination={false}
                        scroll={{ x: "max-content", y: "400px" }}
                        columns={[
                          {
                            title: "Drug Name",
                            dataIndex: "drug_name",
                            key: "drug_name",
                            width: "60%",
                            render: (value) => value || "-",
                          },
                          {
                            title: "Quantity",
                            dataIndex: "quantity_sold",
                            key: "quantity_sold",
                            align: "right",
                            width: "22%",
                            render: (value) =>
                              isNaN(Number(value))
                                ? "0"
                                : Math.round(Number(value)).toLocaleString(), // no decimal, comma format
                          },
                          {
                            title: "Spend ($)",
                            dataIndex: "total_spend",
                            key: "total_spend",
                            align: "right",
                            width: "20%",
                            render: (value) => {
                              const num = Number(value);
                              if (isNaN(num)) return "0.00";
                              return num >= 1_000_000
                                ? (num / 1_000_000).toFixed(2) + "M"
                                : num.toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  });
                            },
                          },
                        ]}
                      />
                    </div>
                  </Card>
                </Col>
              </Row>
              <Row gutter={[16, 16]} className="mt-4">
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <Card
                    title={
                      <div className="flex flex-wrap justify-between items-center gap-y-2">
                        <span className="cardtitle text-base md:text-lg">
                          Top Leakage Dollar (Negative Impact)
                        </span>
                        <div className="flex items-center space-x-2 -mr-1">
                          <InfoCircleOutlined
                            className="cursor-pointer"
                            onClick={() => navigate("/data_table_gpr")}
                          />
                          <MoreOutlined />
                        </div>
                      </div>
                    }
                    className="bg-white CardShadow cardAni tableCard-Custom"
                  >
                    <div className="overflow-x-auto">
                      <Table
                        className="border-table custom-scrollbar min-w-[800px]"
                        style={{ marginTop: "-20px" }}
                        dataSource={TopLeakDetails.map((item, index) => ({
                          ...item,
                          key: `leak-${item.trans_id || index}`,
                        }))}
                        pagination={false}
                        scroll={{ x: "max-content", y: 400 }}
                        columns={[
                          {
                            title: "Rank",
                            dataIndex: "RowNum",
                            key: "RowNum",
                            render: (value) => value || "-",
                            width: "10%",
                          },
                          {
                            title: "GCN",
                            dataIndex: "GCN",
                            key: "GCN",
                            width: "30%",
                            render: (value, record) => {
                              const gcn = value?.trim() || null;
                              const ndcDesc =
                                record["NDC Description"]?.trim() || null;

                              if (!gcn && !ndcDesc) return "-";

                              return (
                                <div className="font-semibold">
                                  {gcn} - {ndcDesc}
                                </div>
                              );
                            },
                          },
                          // {
                          //   title: "GPR Effect at GCN Level, %",
                          //   dataIndex: "GPR Effect",
                          //   key: "GPR Effect",
                          //   align: "right",
                          //   width: "17%",
                          //   render: (value) => {
                          //     const numValue = parseFloat(value) || 0;
                          //     return (
                          //       <div className="flex justify-end items-center gap-1">
                          //         <span>{numValue.toFixed(5)}</span>
                          //         {numValue < 0 ? (
                          //           <ArrowDownOutlined style={{ color: "red" }} />
                          //         ) : (
                          //           <ArrowUpOutlined style={{ color: "green" }} />
                          //         )}
                          //       </div>
                          //     );
                          //   },
                          // },
                          {
                            title: "GPR Effect at GCN Level, %",
                            dataIndex: "GPR Effect",
                            key: "GPR Effect",
                            align: "right",
                            width: "20%",
                            sorter: (a, b) =>
                              parseFloat(a["GPR Effect"] || 0) -
                              parseFloat(b["GPR Effect"] || 0),
                            defaultSortOrder: "ascend", // 👈 Default descending sort
                            render: (value) => {
                              const numValue = parseFloat(value) || 0;
                              return (
                                <div className="flex justify-end items-center gap-1">
                                  <span>{numValue.toFixed(5)}</span>
                                  {numValue < 0 ? (
                                    <ArrowDownOutlined
                                      style={{ color: "red" }}
                                    />
                                  ) : (
                                    <ArrowUpOutlined
                                      style={{ color: "green" }}
                                    />
                                  )}
                                </div>
                              );
                            },
                          },

                          {
                            title: "Purchases (Units)",
                            dataIndex: "PurchaseQuantity",
                            key: "PurchaseQuantity",
                            align: "right",
                            width: "15%",
                            render: (value) =>
                              isNaN(Number(value))
                                ? "0.00"
                                : Number(value).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }),
                          },
                          {
                            title: "Dispenses (Units)",
                            dataIndex: "DispenseQuantity",
                            key: "DispenseQuantity",
                            align: "right",
                            width: "15%",
                            render: (value) =>
                              isNaN(Number(value))
                                ? "0.00"
                                : Number(value).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }),
                          },
                          {
                            title: "Estimated Leakage ($)",
                            dataIndex: "EstimatedLeakage",
                            width: "15%",
                            key: "trans_id",
                            align: "right",
                            render: (value) =>
                              isNaN(Number(value))
                                ? "0.00"
                                : Number(value).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }),
                          },
                        ]}
                      />
                    </div>
                  </Card>
                </Col>
              </Row>

 
            </>
          )}
        </Content>
        {
         ( userAuth?.user_roles_id === 5 || userAuth?.email === "FALCON48124@COMCAST.NET" || userAuth?.email === "AELHASAN@YAHOO.COM" || userAuth?.email === "arborlanerx@sbcglobal.net") && (
         <div className="fixed bottom-6 right-6 flex flex-col items-end group z-50">
  
            <div className="flex flex-col gap-3 mb-3 opacity-0 translate-y-2 pointer-events-none transition-all duration-300 group-hover:opacity-100 group-hover:translate-y-0 group-hover:pointer-events-auto"> 
              {/* <AntTooltip title="Subscribe" placement="left">
                <div
                  onClick={() => {
                    setIsSupportActive(true)
                    setChatOpen(true)
                  }}
                  className="w-12 h-12 rounded-full bg-blue-600 text-white flex items-center justify-center shadow-lg cursor-pointer hover:scale-110 transition-transform duration-200"
                >
                  <Headphones size={20} />
                </div>
              </AntTooltip> */}
              <AntTooltip title="Support" placement="left">
                <div
                  onClick={() => {
                    setIsSupportActive(false)
                    setChatOpen(true)
                  }}
                  className="w-12 h-12 rounded-full bg-emerald-500 text-white flex items-center justify-center shadow-lg cursor-pointer hover:scale-110 transition-transform duration-200"
                >
                  <MessageCircle size={20} />
                </div>
              </AntTooltip>
            </div>
            {userAuth?.email !== "anuja@grapetech.ae" && !chatBoxOpen && (
              <div className="bg-[#000437] text-white px-5 py-3 rounded-full font-semibold shadow-xl cursor-pointer hover:scale-105 transition-all duration-300">
                💬 Let’s Chat
              </div>
            )}
          </div>
          )
        }
      </Layout>
      <AlertMessage
        isVisible={modalVisible}
        onClose={() => setModalVisible(false)}
      />
      <CalculationModal
        isVisible={isVisible}
        onClose={() => setIsVisible(false)}
        data={calculatedData}
        setCalculatedData={setCalculatedData}
        dropdownOptions={gcrPercentage}
        fetchCalculationData={fetchCalculationData}
        selectedGcr={selectedGcr}
        setSelectedGcr={setSelectedGcr}
        isloading={loadingCalc}
        month={selectedOption?.value}
        fetchgprPercentage={fetchgprPercentage}
        setMonth={setSelectedOption}
        selectedPharmacies={selectedPharmacies}
        setIsLoading={setloadingCalc}
      />
      <Chat 
        open={chatBoxOpen}
        setOpen={setChatOpen}
        isSupport={isSupportActive}
        supplierId={supplierId}
        baseAcctId={baseAcctId}
        allAcounts = {AllUser}
      />
      <InputPopUp
        isVisible={targetPopUP}
        onClose={() => setTargetPopUp(false)}
        selectedValue={selectedValue}
        getTargetData={getTargetData}
        month={selectedOption?.value}
        year={selectedOption?.year}
        pharmacy={selectedPharmacies}
        name={userAuth?.first_name}
        value={inputTargetValue}
        email={userAuth?.email}
        currentVal={GCRPer}
        Quarter_GCR={quarterGCRTarget}
        Month_SGCR={SGCRTarget}
        Monthly_GPR={GPRTarget}
        quarterGcrPer={quarterGcrPer}
        monthSgcrPer = {monthSgcrPer}
        monthGprPer={monthGprPer}
      />
    </>
  );
};

export default NewDashboard;


{/* <div className="w-full overflow-x-auto scrollbar-hide">
                      <div className="min-w-[600px]">
                        <div className="performance-table">
                          <div className=" row flex flex-wrap sm:flex-nowrap align-middle ">
                            <span className=" col metric w-full sm:w-1/3 font-bold">
                              Metric
                            </span>
                            <span className="col right w-full sm:w-1/3 text-right font-bold ">
                              Current Month $
                            </span>
                            <span className="col right w-full sm:w-1/3 text-right font-bold  ">
                              Last Month $
                            </span>
                          </div>

                          <div className="row total flex flex-wrap sm:flex-nowrap">
                            <div
                              className=" col metric w-full sm:w-1/3  text-2xl"
                              style={{
                                fontFamily: "Nunito Sans",
                                fontWeight: "800",
                              }}
                            >
                              Total Rx
                            </div>
                            <div className="col right w-full sm:w-1/3 text-right  text-2xl font-bold font-jetbrains">
                              {Number(
                                GCRPer?.raw_data?.Total_Rx || 0
                              ).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </div>
                            <div className="col right w-full sm:w-1/3 text-right    text-2xl font-bold font-jetbrains">
                              {Number(
                                GCRPer?.lastMetrics?.Total_Rx || 0
                              ).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </div>
                          </div>

                          <div className="row section-header  flex flex-wrap sm:flex-nowrap">
                            <div className=" col metric w-full sm:w-1/3 font-bold">
                              Generic RX
                            </div>
                            <div className="col right w-full sm:w-1/3 text-right font-bold">
                              {Number(
                                GCRPer?.raw_data?.Generic_Rx || 0
                              ).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </div>
                            <div className="col right w-full sm:w-1/3 text-right font-bold">
                              {Number(
                                GCRPer?.lastMetrics?.Generic_Rx || 0
                              ).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </div>
                          </div>
                          <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                            <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                              OneStop Rx
                            </div>
                            <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                              {Number(
                                GCRPer?.raw_data?.OnStop_Generic || 0
                              ).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </div>
                            <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                              {Number(
                                GCRPer?.lastMetrics?.OnStop_Generic || 0
                              ).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </div>
                          </div>

                          <div className="row section-header mt-5  flex flex-wrap sm:flex-nowrap">
                            <div className=" col metric w-full sm:w-1/3 font-bold">
                              Brand RX
                            </div>
                            <div className="col right w-full sm:w-1/3 text-right font-bold">
                              {Number(
                                GCRPer?.raw_data?.Brand_Rx || 0
                              ).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </div>
                            <div className="col right w-full sm:w-1/3 text-right font-bold">
                              {Number(
                                GCRPer?.lastMetrics?.Brand_Rx || 0
                              ).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </div>
                          </div>
                          <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                            <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                              GLP1
                            </div>
                            <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                              {Number(
                                GCRPer?.raw_data?.GLP1 || 0
                              ).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </div>
                            <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                              {Number(
                                GCRPer?.lastMetrics?.GLP1 || 0
                              ).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </div>
                          </div>
                          <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                            <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                              HIV
                            </div>
                            <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                              {Number(
                                GCRPer?.raw_data?.HIV_Sum || 0
                              ).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </div>
                            <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                              {Number(
                                GCRPer?.lastMetrics?.HIV_Sum || 0
                              ).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </div>
                          </div>
                          <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                            <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                              Speciality (incl. HIV)
                            </div>
                            <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                              {Number(
                                GCRPer?.raw_data?.Specialty || 0
                              ).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </div>
                            <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                              {Number(
                                GCRPer?.lastMetrics?.Specialty || 0
                              ).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </div>
                          </div>
                          <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                            <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                              Flu + COVID
                            </div>
                            <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                              {Number(
                                GCRPer?.raw_data?.totalFluCovid || 0
                              ).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </div>
                            <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                              {Number(
                                GCRPer?.lastMetrics?.totalFluCovid || 0
                              ).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </div>
                          </div>
                          <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                            <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                              Biosim
                            </div>
                            <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                              {Number(
                                GCRPer?.raw_data?.totalBiosim || 0
                              ).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </div>
                            <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                              {Number(
                                GCRPer?.lastMetrics?.totalBiosim || 0
                              ).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div> */}

{/* Existing chart components
        <Row gutter={[16, 16]} className="mt-6">
          <Col xs={24}>
            <ChartWidget 
              title="Trend Analysis" 
              subtitle="Performance Comparison"
            >
              <BigChartType1 />
            </ChartWidget>
          </Col>
          <Col xs={24}>
            <ChartWidget 
              title="GPR Trading Data" 
              subtitle="Current vs Previous Period"
            >
              <BigChartType2 />
            </ChartWidget>
          </Col>
        </Row>

        {/* Existing table components 
        <Row gutter={[16, 16]} className="mt-4">
          <Col span={24}>
            <Card title="Top Leakage Details">
              <BigTable />
            </Card>
          </Col>
        </Row>

        <Row gutter={[16, 16]} className="mt-4">
          <Col span={16}>
            <Card title="Detailed Analysis">
              <NarrowTable />
            </Card>
          </Col>
          <Col span={8}>
            <Card title="Summary">
              <SmallTable />
            </Card>
          </Col>
        </Row> */}